import { render, staticRenderFns } from "./ShowScanTaskRecord.vue?vue&type=template&id=8368378e&"
import script from "./ShowScanTaskRecord.vue?vue&type=script&lang=js&"
export * from "./ShowScanTaskRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports